import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { KI_REGION_KEYS, KiVerbindungInfo } from '../../../models/ki.model';
import { KiMarkComponent } from '../ki-mark/ki-mark.component';

let naechsteTitelNr = 0;

/**
 * Hinweis vor der ersten KI-Anfrage (page-ki.jsx:78-100). Der Aufrufer blendet ihn per {@code @if}
 * ein; z-index 320 legt ihn auch über ein offenes KI-Panel (280).
 */
@Component({
  selector: 'app-ki-erste-nutzung',
  imports: [A11yModule, KiMarkComponent, MatButtonModule, TranslatePipe],
  templateUrl: './ki-erste-nutzung.component.html',
  styleUrl: './ki-erste-nutzung.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiErsteNutzungComponent {
  readonly verbindung = input.required<KiVerbindungInfo>();
  readonly verstanden = output<void>();
  readonly abgebrochen = output<void>();

  protected readonly titelId = `ki-erste-nutzung-titel-${++naechsteTitelNr}`;
  protected readonly regionKey = computed(() => {
    const region = this.verbindung().region;
    return Object.hasOwn(KI_REGION_KEYS, region) ? KI_REGION_KEYS[region] : null;
  });

  protected escape(event: Event): void {
    event.stopPropagation();
    this.abgebrochen.emit();
  }
}
